import * as Yup from "yup";

export const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password be at least 8 characters long")
    .max(20, "Passowrd length should be less than 20 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[¡!₩¥€÷×@#$%`°•○●□■♤♡◇♧》¤▪︎☆^&*()\-_=+{}\[\];':,<.>£§~?|¿]).\S*$/,
      "Passwords must have upper, lower case letters, at least 1 number, special character and no whitespace allowed"
    )
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password does not match")
    .required("Password confirmation is required"),
});
